<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="card-header"><h4>Adicionar Plano</h4></div>
        <div class="row">
          <div class="col-md-4">
            <select
              class="form-select"
              v-model="state.plano_id"
              @change="setPlanoNome($event.target.selectedOptions[0].innerHTML)"
            >
              <option
                v-for="plano in state.planos"
                :value="plano.id"
                :key="plano.id"
              >
                {{ plano.nome }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <button @click="adicionarPlano()" class="btn-add" type="button">
              Adicionar
            </button>
          </div>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Nome</th>
              <th scope="col">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(plano, index) in state.array_plano" :key="plano.id">
              <td scope="row">{{ plano.id }}</td>
              <td>{{ plano.nome }}</td>
              <td>
                <button
                  title="Deletar"
                  @click="deletarPlano(index)"
                  type="button"
                  class="btn btn-danger"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
                    />
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="btns_right">
          <button @click="savePlano" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/clinicas">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      planos: [],
      array_plano: [],
      plano_id: "",
      plano: {},
    });
    onMounted(() => {
      fetchPlanos();
      if (router.currentRoute._value.params.id != undefined) {
        fetcClinica();
      }
    });
    async function fetcClinica() {
      try {
        const { data } = await services.clinica.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.clinica = data;
        state.clinica_id = data.id;
        state.array_plano = data.planos;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchPlanos() {
      try {
        const { data } = await services.plano.getAll({
          token,
        });
        console.log(data);
        state.planos = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function adicionarPlano() {
      var plano = {};
      plano.id = state.plano_id;
      plano.nome = state.plano_selecionado_nome;
      state.array_plano.push(plano);
    }
    function setPlanoNome(valor) {
      state.plano_selecionado_nome = valor;
    }
    async function deletarPlano(plano_i) {
      state.array_plano.splice(plano_i, 1);
    }
    async function savePlano() {
      try {
        await services.clinica.savePlano({
          clinica_id: state.clinica_id,
          planos: state.array_plano,
          token,
        });
        router.push({ name: "Clinicas" });
      } catch (error) {
        console.log(error);
      }
    }

    return {
      router,
      state,
      setPlanoNome,
      adicionarPlano,
      deletarPlano,
      savePlano,
    };
  },
};
</script>
  <style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #47b0a9;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #47b0a9;
}
.btns_right {
  text-align: right;
  margin-top: 1rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #47b0a9;
}
#pills-home-tab {
  color: #000;
}
#pills-home-tab:focus {
  color: #47b0a9;
}
#pills-profile-tab {
  color: #000000;
}
#pills-profile-tab:focus {
  color: #47b0a9;
}
.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}
tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}
thead {
  color: #000;
  text-align: center;
  background: gray;
}
td {
  color: #000;
  text-align: center;
}
.table {
  margin-top: 2rem;
}
.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}
</style>